import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container-fluid admin-top" }
const _hoisted_2 = { class: "sidenav" }
const _hoisted_3 = { class: "component-box" }
const _hoisted_4 = { class: "box-contents" }
const _hoisted_5 = { class: "box-row" }
const _hoisted_6 = { class: "box-row" }
const _hoisted_7 = { class: "box-row" }
const _hoisted_8 = { class: "box-row" }
const _hoisted_9 = {
  key: 0,
  class: "box-row"
}
const _hoisted_10 = {
  key: 1,
  class: "box-row"
}
const _hoisted_11 = {
  key: 2,
  class: "box-row"
}
const _hoisted_12 = {
  key: 3,
  class: "box-row"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { key: 1 }

import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useAuth } from 'src/composables/useAuth';
import { useFullScreenSpinner } from 'src/composables/useFullScreenSpinner';


export default /*@__PURE__*/_defineComponent({
  __name: 'Top',
  setup(__props) {

const spinner = useFullScreenSpinner();
const showFullScreenSpinner = computed(() => spinner.show);
const spinnerMessage = computed(() => spinner.message);
const isHtmlSpinnerMessage = computed(() => spinner.isHtmlMessage);

const route = useRoute();
const routeName = computed(() => route.name);

const { user } = useAuth();
const hasRoleOperationsAdmin = computed(() => user?.hasRoleOperationsAdmin ?? false);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LoadWaitSpinner = _resolveComponent("LoadWaitSpinner")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "box-header-bar" }, " 管理画面 ", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: _normalizeClass({ selected: routeName.value === 'AdminGroups2' })
            }, [
              _createVNode(_component_router_link, {
                to: { name: 'AdminGroups2' },
                class: "nav-link"
              }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode(" 事業所管理 ", -1)
                ]))]),
                _: 1
              })
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: _normalizeClass({ selected: routeName.value === 'AdminGroups3' })
            }, [
              _createVNode(_component_router_link, {
                to: {name: 'AdminGroups3' },
                class: "nav-link"
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode(" 部署管理 ", -1)
                ]))]),
                _: 1
              })
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              class: _normalizeClass({ selected: routeName.value === 'AdminUsers' })
            }, [
              _createVNode(_component_router_link, {
                to: { name: 'AdminUsers' },
                class: "nav-link"
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode(" ユーザー管理 ", -1)
                ]))]),
                _: 1
              })
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              class: _normalizeClass({ selected: routeName.value === 'AdminDevices' })
            }, [
              _createVNode(_component_router_link, {
                to: { name: 'AdminDevices' },
                class: "nav-link"
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode(" 車載器管理 ", -1)
                ]))]),
                _: 1
              })
            ], 2)
          ]),
          (hasRoleOperationsAdmin.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", {
                  class: _normalizeClass({ selected: routeName.value === 'AdminMovieGroups' })
                }, [
                  _createVNode(_component_router_link, {
                    to: { name: 'AdminMovieGroups' },
                    class: "nav-link"
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode(" 動画管理 ", -1)
                    ]))]),
                    _: 1
                  })
                ], 2)
              ]))
            : _createCommentVNode("", true),
          (hasRoleOperationsAdmin.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", {
                  class: _normalizeClass({ selected: routeName.value === 'AdminTags' })
                }, [
                  _createVNode(_component_router_link, {
                    to: { name: 'AdminTags' },
                    class: "nav-link"
                  }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createTextVNode(" 動画タグ管理 ", -1)
                    ]))]),
                    _: 1
                  })
                ], 2)
              ]))
            : _createCommentVNode("", true),
          (hasRoleOperationsAdmin.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", {
                  class: _normalizeClass({ selected: routeName.value === 'AdminComments' })
                }, [
                  _createVNode(_component_router_link, {
                    to: { name: 'AdminComments' },
                    class: "nav-link"
                  }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode(" 付箋管理 ", -1)
                    ]))]),
                    _: 1
                  })
                ], 2)
              ]))
            : _createCommentVNode("", true),
          (hasRoleOperationsAdmin.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", {
                  class: _normalizeClass({ selected: routeName.value === 'AdminCommentTypes' })
                }, [
                  _createVNode(_component_router_link, {
                    to: { name: 'AdminCommentTypes' },
                    class: "nav-link"
                  }, {
                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                      _createTextVNode(" 付箋種別管理 ", -1)
                    ]))]),
                    _: 1
                  })
                ], 2)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (showFullScreenSpinner.value)
      ? (_openBlock(), _createBlock(_component_LoadWaitSpinner, { key: 0 }, {
          message: _withCtx(() => [
            (spinnerMessage.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  (isHtmlSpinnerMessage.value)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        innerHTML: spinnerMessage.value
                      }, null, 8, _hoisted_14))
                    : (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(spinnerMessage.value), 1))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ]))
}
}

})